import type { EnvironmentProviders } from '@angular/core';
import { makeEnvironmentProviders } from '@angular/core';
import { provideTransloco } from '@jsverse/transloco';
import { translocoConfig } from './transloco.config';

export function translocoEnvironmentProvider(): EnvironmentProviders {
  return makeEnvironmentProviders([provideTransloco(translocoConfig)]);
}
